import { render } from "./InputSwitch.vue?vue&type=template&id=5e0d975d"
import script from "./InputSwitch.vue?vue&type=script&lang=js"
export * from "./InputSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__